import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { CssBaseline, Box } from '@mui/material'
import { Provider } from 'react-redux'
import { store } from './store'
import { AuthProvider } from './components/auth/AuthProvider'
import AppRoutes from './routes'

// Arabic RTL theme
const theme = createTheme({
  direction: 'rtl',
  typography: {
    fontFamily: [
      'Cairo',
      'Inter',
      'Arial',
      'sans-serif'
    ].join(','),
  },
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
})

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router basename={process.env.REACT_APP_BASENAME || '/'}>
          <AuthProvider>
            <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
              <AppRoutes />
            </Box>
          </AuthProvider>
        </Router>
      </ThemeProvider>
    </Provider>
  )
}

export default App
